import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Backdrop,
  makeStyles
} from '@material-ui/core'
import MessageAllHistoryDetailList from './MessageAllHistoryDetailList'

const useStyles = makeStyles(theme => ({
  dialog: {},
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

type Props = {
  isOpen: boolean
  closeHandler: () => void
  subjectGroupId: number | null
}

const MessageAllHistoryDetailModal: React.FC<Props> = ({
  isOpen,
  closeHandler,
  subjectGroupId
}) => {
  const classes = useStyles()
  const handleClose = () => {
    closeHandler()
  }

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={isOpen}
      onClose={handleClose}
      BackdropComponent={Backdrop}
      closeAfterTransition
      className={classes.dialog}
    >
      <DialogContent>
        <MessageAllHistoryDetailList subjectGroupId={subjectGroupId} />
      </DialogContent>
      <DialogActions className={classes.flexCenter}>
        <Button variant="contained" onClick={handleClose} color="primary">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MessageAllHistoryDetailModal
